import { useState } from 'react';

import { Modal } from 'antd';

import ChaveConfiguracaoForm from '../../../components/chavesConfiguracao/form';
import { registerChave } from '../../../services/configuracoes';

export default function AddChave({ visible, setVisible, onConfirm }) {
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const onFinish = async (values) => {
      try {
        setLoading(true);
        console.log(values);
        await registerChave(values);
        setVisible(false);
        onConfirm();
      } catch (err) {
        console.log(err.error);
        setError(err.error);
      } finally {
        setLoading(false);
      }
    };
    return (
      <Modal
        title="Adicionar chave de configuração"
        centered
        footer={null}
        visible={visible}
        onCancel={() => setVisible(false)}
      >
        <ChaveConfiguracaoForm
          onFinish={onFinish}
          error={error}
          setError={setError}
          loading={loading}
        />
      </Modal>
    );
  }